import { BaggageType, GdsServiceVipSubType, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';

import {
	LoadingServiceActionTypes,
	setLoadingServicesParams,
	addLoadingServiceParam,
	clearLoadingServicesParams
} from './actions';

export enum LoadingServiceType {
	Insurance = 'Insurance',
	Transfer = 'Transfer'
}

export interface LoadingServicesParamsState {
	id: string[];
	rfisc: string[];
	subType: (BaggageType | GdsServiceVipSubType)[];
	type: (OrderAdditionalServiceGdsServiceServiceType | LoadingServiceType)[];
}

const initialState: LoadingServicesParamsState = {
	id: [],
	rfisc: [],
	subType: [],
	type: []
};

export const loadingServicesParamsReducer = (
	state: LoadingServicesParamsState = initialState,
	action: LoadingServiceActionTypes
) => {
	switch (action.type) {
		case setLoadingServicesParams.toString():
			return action.payload;
		case addLoadingServiceParam.toString():
			const newState = { ...state };

			const actionPayload = action.payload as Partial<LoadingServicesParamsState>;
			for (const param in actionPayload) {
				if (actionPayload[param]) {
					newState[param] = [...newState[param], ...actionPayload[param]];
				}
			}

			return newState;
		case clearLoadingServicesParams.toString():
			return initialState;
		default:
			return state;
	}
};
